import React from "react";
import { profile } from "../../../assets/index.js"; 
import { Button, Form, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
const Profile = () => {
  return (
    <div className="container my-5  ">
      <div className="row justify-content-center ">
        <div className="col-lg-4 col-md-6 mt-2  ">
          <Card className="shadow-lg border-0 ">
            <Card.Body className="text-center background-dark bg-gradient ">
              <h5 className="mb-4 p-3 landing-text-white">Edit Profile</h5>
              <div className="d-flex flex-column align-items-center ">
                <img
                  src={profile}
                  alt="Profile"
                  className="rounded-circle border-0 p-1 bg-warning mb-4"
                  width="120"
                  style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}
                />
                <div>
                  <h6 className="mb-2 font-weight-bold landing-text-white">Name: ----</h6>
                  <p className="text-muted mb-2 landing-text-white">Password: ****</p>
                  <p className="text-muted mb-5 landing-text-white">Additional details</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-6 col-md-8 mt-2 ">
          <Card className="shadow-lg border-0 background-dark bg-gradient">
            <Card.Body>
              <Form>
                <h5 className="mb-4 text-center p-1 landing-text-white">Update Profile Information</h5>

                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Control
                    type="email"
                    placeholder="Enter your email"
                    className="p-3"
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Control
                    type="password"
                    placeholder="Enter your password"
                    className="p-3"
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicConfirmPassword">
                  <Form.Control
                    type="password"
                    placeholder="Confirm your password"
                    className="p-3"
                  />
                </Form.Group>
                <Link to="/dashboard">
                <div className="d-flex justify-content-center p-2 mb-3">
               
                  <Button
                    variant="success"
                    type="submit"
                    className="w-50 py-2"
                
                  >
                    Update Profile
                  </Button>
                 
                </div>
                 </Link>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Profile;
